<template>
  <div @click.stop class="week-popover">
    <el-popover placement="bottom-start" :value="visible" title="" width="330" trigger="manual">
      <el-input slot="reference" @focus="onShow" placeholder="请选择周" :value="showSelectWeek">
        <i slot="prefix" class="el-input__icon el-icon-date"></i>
      </el-input>

      <div class="week">
        <div class="header" style="text-align:center;padding:0">
          <div>
            <button type="button" style="padding: 10px; margin: 0" aria-label="前一年" @click="onPrevY" class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"></button>
            <button type="button" style="padding: 10px; margin: 0" aria-label="前一月" @click="onPrevM" class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left"></button>
          </div>
          <span>{{`${curY} 年 ${curM} 月`}}</span>
          <div>
            <button type="button" style="padding: 10px; margin: 0" aria-label="后一年" @click="onNextY" class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"></button>
            <button type="button" style="padding: 10px; margin: 0" aria-label="后一月" @click="onNextM" class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right"></button>
          </div>
        </div>
        <div class="week-list" style="padding-bottom: 10px;">
          <div class="week-item" :style="curYMWeek.length > 4 ? 'width: 33.3%;':'width: 50%;'" v-for="(week, index) in curYMWeek" :key="index">
            <el-button :disabled="week.disabled" :type="isSelectedWeek(week) ? 'primary' :''" @click.stop="onSelectWeek(week)">第 {{week.week}} 周</el-button>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import http from '@/api/freight.js' //请求汇总
import moment from 'moment'
import weekMixin from './weekMixin'

export default {
  name: 'week-popover',
  data() {
    return {
      visible: false,
      curSelectedWeek: null,
    }
  },
  mixins: [weekMixin],
  mounted() {
    document.addEventListener(
      'click',
      () => {
        if (this.visible) {
          this.visible = false
        }
      },
      false
    )
    this.getLatestWeek()
  },
  computed: {
    showSelectWeek() {
      return this.curSelectedWeek
        ? `${this.curSelectedWeek.year} 年 ${this.curSelectedWeek.month} 月 第 ${this.curSelectedWeek.week} 周`
        : ''
    },
    isSelectedWeek() {
      return function (week) {
        return (
          this.curSelectedWeek &&
          week.year == this.curSelectedWeek.year &&
          week.month == this.curSelectedWeek.month &&
          week.week == this.curSelectedWeek.week
        )
      }
    },
  },
  methods: {
    getLatestWeek() {
      http
        .getLatestWeekData3()
        .then((e) => {
          let tmpData = e.data
          if (this.$route.query.year){
            this.curSelectedWeek = {
              year:this.$route.query.year,
              month:this.$route.query.month,
              week:this.$route.query.week
            }
            this.$emit('on-command', { type: 'default-week' })
          }else{
            if (tmpData) {
              this.curSelectedWeek = tmpData
              this.$emit('on-command', { type: 'default-week' })
            }
          }
          this.getWeek(this.curSelectedWeek.year)
        })
        .catch((err) => {
          console.error(err)
        })
    },

    onShow() {
      this.visible = true
      if (this.curSelectedWeek) {
        this.curY = this.curSelectedWeek.year
        this.curM = this.curSelectedWeek.month
      } else {
        this.curY = moment().year()
        this.curM = 1 + moment().month()
      }
    },
    onSelectWeek(week) {
      this.visible = false
      this.curSelectedWeek = week
    },
  },
}
</script>

<style lang="stylus" scoped>
@import './week.styl';
</style>
